module.exports = __webpack_public_path__ + "img/f2.8492c36c.png";